<script>
    export default {
        extends: require('./File.vue'),
        name: 'form-photo',
        props: {
            emptyMessage: {
                type: String,
                default: 'Selecione uma imagem'
            },
            selectedMessage: {
                type: String,
                default: 'Mudar imagem'
            }
        },
        created () {
            this.types = {
                'image/.*': 'Imagens'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Photo.vue?22860d70